import { getPath } from './location';

export interface PathPerformance {
  path: string;
  endTime: number;
}

export const pathActiveConnections = new Map<string, number>();

export function recordApi() {
  const path = getPath();
  pathActiveConnections.set(path, (pathActiveConnections.get(path) || 0) + 1);

  return () => finishApi(path);
}

function finishApi(path: string) {
  const currentActiveConnections = (pathActiveConnections.get(path) as number) - 1;

  pathActiveConnections.set(path, currentActiveConnections);
  if (!currentActiveConnections) {
    if (typeof document !== 'undefined') {
      document.dispatchEvent(
        new CustomEvent('SPAPageLoad', {
          detail: {
            path,
            endTime: +new Date(),
          },
        }),
      );
    }
  }
}
